// extracted by mini-css-extract-plugin
export default {"cls1":"TypeWriter-cls1___679320020693d882394","cls2":"TypeWriter-cls2___8e6450823eb04b0b2e8 TypeWriter-cls1___679320020693d882394"};